import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2123_4304)" }, [
      _createElementVNode("path", {
        fill: "#FF4C51",
        d: "M24 12c0 6.624-5.376 12-12 12-6.612 0-12-5.376-12-12C0 5.388 5.388 0 12 0c6.624 0 12 5.388 12 12M10.765 4.624c-1.06 0-1.718.647-1.718 1.647v.976H6.13a.525.525 0 0 0-.517.53c0 .282.235.505.517.505h.989l.423 9.589c.024.823.506 1.282 1.33 1.282h6.27c.812 0 1.318-.459 1.353-1.282l.412-9.589h.953a.51.51 0 0 0 .517-.506.51.51 0 0 0-.517-.529h-2.906v-.976c0-1-.67-1.647-1.741-1.647zm-.66 5.152.236 7.083c0 .235-.164.411-.423.411-.247 0-.447-.176-.447-.411l-.247-7.083c0-.258.152-.423.447-.423.247 0 .435.165.435.423m2.33 0v7.083c0 .235-.176.411-.447.411-.27 0-.447-.176-.447-.411V9.776c0-.258.165-.423.447-.423.27 0 .447.165.447.423m2.306 0-.247 7.083c0 .235-.2.411-.447.411-.259 0-.424-.176-.424-.411l.236-7.083c.012-.258.188-.423.447-.423.282 0 .435.165.435.423m-1.047-3.435v.906h-3.412v-.906c0-.317.224-.53.553-.53h2.306c.33 0 .553.213.553.53"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2123_4304" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }